import {BaseHandleErrorMapper} from "@app/core/shared/infrastructure/base.handler/base-handle-error.mapper";
import {HttpErrorResponse} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {CouponAlreadyUsedError} from "@app/core/coupon/domain/coupon-already-used.error";
import {InfrastructureError, InfrastructureErrorType} from "@app/core/shared/domain/infrastructure.error";
import {ApiErrorCode} from "@app/core/shared/domain/api.error";
import {catchError} from "rxjs/operators";

/**
 * Mapper for mapping the error response when validating a coupon
 */
export class ValidateCouponErrorMapper extends BaseHandleErrorMapper{
    public static handleCouponError(errorResponse: HttpErrorResponse): Observable<never>{
        return super.handleError(errorResponse).pipe(
            catchError(error => {
                return this.handleCouponAlreadyUsedError(error)
            })
        )
    }

    private static handleCouponAlreadyUsedError(error: Error): Observable<never> {
        // If the error is not a CouponAlreadyUsedError, return the error as it is
        if (!checkIsCouponAlreadyUsedError(error)) {
            return throwError(() => error);
        }
        const apiError = error.apiError;
        // If the apiError is null, it means that the error is not a backend error
        if (apiError == null) {
            return throwError(() => error);
        }
        return throwError(() => new CouponAlreadyUsedError(apiError.message, apiError.extraInfo, error, apiError));
    }

}

function checkIsCouponAlreadyUsedError(error: Error): error is InfrastructureError {
    const isInfrastructureError = error instanceof InfrastructureError;
    const isBackendError = isInfrastructureError && error.type === InfrastructureErrorType.BackendError;
    return isBackendError && error.apiError?.code === ApiErrorCode.COUPON_ALREADY_USED;
}
